import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';
import Api from './Config';

export default class AdminNavBar extends Component {
  changeLink(link) {
    this.props.history.push(`/${link}`);
  }

  doLogout() {
    localStorage.setItem('UID', '');
    Api.logout().catch((e) => {});
    this.props.history.push('/');
  }

  render() {
    return (
      <nav className="navbar navbar-default">
        <div className="container-fluid">
          <div className="navbar-header">
            <button
              type="button"
              className="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#navbar"
              aria-expanded="false"
              aria-controls="navbar"
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar" />
              <span className="icon-bar" />
              <span className="icon-bar" />
            </button>
            <a
              onClick={() => {
                this.changeLink('RegisterDoctor');
              }}
              className="navbar-brand"
              style={{ cursor: 'pointer' }}
            >
              CAREMINDr Providers Admin Portal
            </a>
          </div>
          <div id="navbar" className="navbar-collapse collapse">
            <ul className="nav navbar-nav">
              <li className={this.props.location.pathname == '/RegisterDoctor' ? 'active' : ''}>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    this.changeLink('RegisterDoctor');
                  }}
                >
                  Provider Offices
                </a>
              </li>

              <li className={this.props.location.pathname == '/ArchivedDoctors' ? 'active' : ''}>
                <a
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    this.changeLink('ArchivedDoctors');
                  }}
                >
                  Archived Offices
                </a>
              </li>

              <li className={this.props.location.pathname == '/CreateNewDoctor' ? 'active' : ''}>
                {' '}
                <a
                  onClick={() => {
                    this.changeLink('CreateNewDoctor');
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  Create New
                </a>
              </li>

              <li className={this.props.location.pathname == '/groups' ? 'active' : ''}>
                {' '}
                <a
                  onClick={() => {
                    this.changeLink('groups');
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  Groups
                </a>
              </li>

              <li className={this.props.location.pathname == '/messageTemplates' ? 'active' : ''}>
                {' '}
                <a
                  onClick={() => {
                    this.changeLink('messageTemplates');
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  Msg Template
                </a>
              </li>
              <li className={this.props.location.pathname == '/clusters' ? 'active' : ''}>
                {' '}
                <a
                  onClick={() => {
                    this.changeLink('clusters');
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  Clusters
                </a>
              </li>

              <li className={this.props.location.pathname == '/reviewerManager' ? 'active' : ''}>
                {' '}
                <a
                  onClick={() => {
                    this.changeLink('reviewerManager');
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  Roles
                </a>
              </li>

              <li className={this.props.location.pathname == '/ActivityReport' ? 'active' : ''}>
                {' '}
                <a
                  onClick={() => {
                    this.changeLink('ActivityReport');
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  Activity Report
                </a>
              </li>

              <li className={this.props.location.pathname == '/ContentManagement' ? 'active' : ''}>
                {' '}
                <a
                  onClick={() => {
                    this.changeLink('ContentManagement');
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  TOS PP Text
                </a>
              </li>

              <li className={this.props.location.pathname == '/LifelineManagement' ? 'active' : ''}>
                {' '}
                <a
                  onClick={() => {
                    this.changeLink('LifelineManagement');
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  LifeLine
                </a>
              </li>

              {false && (
                <li className={this.props.location.pathname == '/faxes' ? 'active' : ''}>
                  {' '}
                  <a
                    onClick={() => {
                      this.changeLink('faxes');
                    }}
                    style={{ cursor: 'pointer' }}
                  >
                    Faxes
                  </a>
                </li>
              )}
            </ul>
            <ul className="nav navbar-nav navbar-right">
              <li>
                <a>Admin</a>
              </li>
              <li
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  this.doLogout();
                }}
              >
                <a>Logout</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}
